
import { Component } from '@angular/core';
import { IResultadoGeneral } from './../models/resultadogeneral';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmEventType, ConfirmationService, MessageService } from 'primeng/api';
import { saveAs } from 'file-saver';
import ICredencialUsuario from '../models/credencial';
import { ICiudad } from '../models/ciudad';
import { InombreCompletoChofer } from '../models/nombreCompletoChofer';
import { IMes } from '../models/mes';
import { IrptEstatusForaneo } from '../models/rptEstatusForaneo';
import { IEstatusForaneo } from '../models/estatusforaneo';
import { ISemanasHappyMile } from '../models/semanas';
import { SemanaService } from '../services/semana.service';
import { AuthService } from '../services/auth.service';
import { ICiudadHM } from '../models/ciudadhm';
import { CiudadhmService } from './../services/ciudadhm.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BonoRecomendacionService } from '../services/bonorecomendacion.service';
import { INomina } from '../models/nomina';
import { IJsonDia } from '../models/json_dia';
import { IDeducciones } from '../models/deducciones';
import { RecibodigitalService } from '../services/recibodigital.service';
import { IRecibopdf } from '../models/reciboPdf';



@Component({
  selector: 'app-recibodigital',
  templateUrl: './recibodigital.component.html',
  styleUrls: ['./recibodigital.component.scss']
})
export class RecibodigitalComponent {

  @ViewChild('dt1') dt!: Table;
  lstCiudad: ICiudadHM[] = [];
  lstCiudad2: ICiudadHM[] = [];
  lstChoferes: InombreCompletoChofer[] = [];
  lstchofCopy: InombreCompletoChofer[] = [];
  lstEstatusForaneo: IEstatusForaneo[] = [];

  lstRecibopdf: IRecibopdf[] = [];
  lstSemanas: ISemanasHappyMile[] = [];
  lstNominaPorCiudad: INomina[] = [];
  lstJsonPorDia: IJsonDia[]=[];

  mssgListaCiudades: string = '';
  selectedSemana: ISemanasHappyMile = {
    idx: 0,
    id_semana: 0,
    nom_semana: '',
    anio: 0,
    fec_inicio: '',
    fec_fin: '',
    clv_activo: 0
  };
  selectedSemanaReporte: ISemanasHappyMile = {
    idx: 0,
    id_semana: 0,
    nom_semana: '',
    anio: 0,
    fec_inicio: '',
    fec_fin: '',
    clv_activo: 0
  };

  lstrptDescansoFaltas: IrptEstatusForaneo[] = [];
  selectedCiudad: ICiudad = {
    id: 0,
    nombre: '',
    clave_Estado: '',
    id_ciudad_principal: 0
  };

  //num_anio: number= 0;
  years: number[] = [];
  loading: boolean = false;
  anio_filtro:any;

  //variables usadas para la fecha, fueron casteadas ya que presentaban errorees
  dia: any = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
  fecha_dia: any = new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
  anio: any = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
  fecha_fin: any = null;
  id_ciudad_hm: number = 0;
  id_ciudad_principal: number = 0;
  texto_operacion: string = '';
  num_operacion: number = 0;
  clv_operacion: number = 0;
  habilitar_agregar: boolean = false;
  resultado: IResultadoGeneral = {
    clv_estatus: 0,
    messageDetails: ''
  };
  habilitaragregar :boolean=false;
  dspDeduccion:boolean = false;
  dsblstCiudades: boolean = true;
  dsblstColaboradores: boolean = true;
  dsblstCiudadesAdscritas: boolean = true;
  // variables de reportes--------------------------
  dbsReportes: boolean = false;
  fecha_fin_filtro: any = null;
  ButtonExportExcel: boolean = false;
  //Fecha de Dias Atras
  fecha_del_dia: any = null;
  mostrar_texto_fechas: number = 0;
  fecha_final_dia!: Date;
  //Fecha para restar 3 dias
  fecha_minus3 !: Date;
  fecha_dia_real: any = null;
  selectedMesReporte1: IMes = {
    num_mes: -1,
    nombre: ""
  }
  id_ciudad_hm_rpt: number=0;
  deshabilitarbtnexportar:boolean=false;
  imp_total_genral : number = 0;
  anioReporte1: any;
  loading_reporte1: boolean = false;
  meses: IMes[] = [
    { num_mes: 1, nombre: "Enero" },
    { num_mes: 2, nombre: "Febrero" },
    { num_mes: 3, nombre: "Marzo" },
    { num_mes: 4, nombre: "Abril" },
    { num_mes: 5, nombre: "Mayo" },
    { num_mes: 6, nombre: "Junio" },
    { num_mes: 7, nombre: "Julio" },
    { num_mes: 8, nombre: "Agosto" },
    { num_mes: 9, nombre: "Septiembre" },
    { num_mes: 10, nombre: "Octubre" },
    { num_mes: 11, nombre: "Noviembre" },
    { num_mes: 12, nombre: "Diciembre" }];

    reactiveformDeduccion: FormGroup = new FormGroup({
      idx: new FormControl(0),
      nom_chofer: new FormControl(''),
      cod_chofer: new FormControl(0, [Validators.min(1),Validators.required]),
      id_ciudad_hm: new FormControl(0),
      num_anio: new FormControl(new Date().getFullYear()),
      //id_semana: new FormControl(0, [Validators.min(1),Validators.required]),
      selectedSemana : new FormControl([],[Validators.min(1),Validators.required]),
      nombreCiudad: new FormControl(''),
      fec_inicio : new FormControl(''),
      fec_fin : new FormControl(''),
      imp_deduccion: new FormControl(0,[Validators.min(1),Validators.required]),
      clv_activo: new FormControl(0),
    });

  //Permisos
  user: ICredencialUsuario = {};
  constructor(


    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private semanaService: SemanaService,
    private recibodigitalService:RecibodigitalService,
    private auth: AuthService,
    private CiudadhmService: CiudadhmService,
    private bonoRecomendacionService: BonoRecomendacionService,

    ) {

    this.initializeYears();
   // this.num_anio = new Date().getFullYear();
    this.cargarInformacionUsuario();

    this.reactiveformDeduccion.controls['selectedSemana'].valueChanges.subscribe(data => {
      if (data==null) {
        //this.resetearFormularios();
        this.reactiveformDeduccion.controls['fec_inicio'].setValue('');
        this.reactiveformDeduccion.controls['fec_fin'].setValue('');
      } else {
        this.reactiveformDeduccion.controls['fec_inicio'].setValue(data.fec_inicio);
        this.reactiveformDeduccion.controls['fec_fin'].setValue(data.fec_fin);
      }
    });
  }

  ngOnInit(): void {
    this.cargaInicial();
    this.cargarListadoDeSemanasAnio();
    this.cargaListaChoferes();
    this.inicializarFechas();
  }

  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  initializeYears(): void {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= currentYear - 5; year--) {
      this.years.push(year);
    }
  }

  cargarListadoDeSemanasAnio_cast(num_anio:any) {
    let anio_cast: any = 0;
    if (num_anio instanceof Date) {
      // will execute
      anio_cast = num_anio.getFullYear();
    } else {
      anio_cast = num_anio;
    }
    this.lstSemanas = [];
    this.semanaService.listarSemanas(anio_cast).subscribe((resp) => {
      this.lstSemanas = resp;
      //reiniciar
      this.lstNominaPorCiudad = [];
      this.lstJsonPorDia=[];
      setTimeout(() => {
      },
        600);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>Error al cargar Semanas HM</b>. Contacte al Administrador.');
      });
  }

  consultaSemanas() {
    alert('Historico');
  }

  inicializarFechas() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.anio = getYear;
    this.anio_filtro = getYear;
  }






// metodos para eñ filtro para fechas
  getTargetDescription(ruta: ISemanasHappyMile) {
    let fec_inicio = new Date(ruta.fec_inicio);
    let fec_fin = new Date(ruta.fec_fin);
    return this.formatearFechas(fec_inicio) + ' | ' + this.formatearFechas(fec_fin);
  }

  formatearFechas(fecha: Date): string {
    let fecha_Cast = '';
    var getYear = new Date(fecha).toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date(fecha).toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit' });
    fecha_Cast = getDay + '/' + getMonth + '/' + getYear;
    return fecha_Cast;
  }

  cargarListadoDeSemanasAnio() {
    this.lstSemanas = [];
    this.semanaService.listarSemanas(this.anio).subscribe((resp) => {
      this.lstSemanas = resp;
      setTimeout(() => {
      },
        600);
    },
      (error) => {
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> al cargar Información. Contacte al Administrador.');
      });
  }


  // -----------filtra y carga la informacion ----
  Filtrar() {

    this.loading = true;
    if (this.id_ciudad_hm == null || typeof this.id_ciudad_hm === 'undefined' || !this.selectedSemana || this.selectedSemana.id_semana == null || typeof this.selectedSemana.id_semana === 'undefined') {
      this.mostrarDialogoInformativoSincontacteadmi('<b>Informativo</b> Debe seleccionar una semana para poder filtrar');
      this.loading = false;
    } else   {
      this.habilitaragregar= true;
      this.recibodigitalService.getListadodeducciones(this.selectedSemana.anio, this.id_ciudad_hm,this.selectedSemana.id_semana ).subscribe(
        (resp) => {
          this.lstRecibopdf = resp;
          if (this.lstRecibopdf.length === 0) {
            this.loading = false;
            this.mostrarDialogoInformativoSincontacteadmi('<b>No Existe</b> Registros para la Fecha seleccionada');
          }
          else {
            setTimeout(() => {
              this.loading = false;
            }, 800);
          }
        },
        (error) => {
          this.mostrarDialogoInformativoSincontacteadmi('<b>ERROR</b> en Cargar Movimientos ');
          this.loading = false;
        }
      );
    }
  }



  mostrarDialogoInformativoSincontacteadmi(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario ;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }



  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  cargaListaChoferes() {
    this.dsblstColaboradores = true;
    this.lstChoferes = [];
    this.bonoRecomendacionService.getListadoChoferesGeneral(this.id_ciudad_hm).subscribe((resp) => {
      this.lstChoferes = resp;
      setTimeout(() => {
        this.dsblstColaboradores = false;
      }, 100);
    },
      (error) => {
        this.dsblstColaboradores = false;
        this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Colaboradores');
      });
  }



  cargaInicial() {
    this.dsblstCiudades = true;
    this.loading = true;
    this.CiudadhmService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudad = resp.slice(); // Crear una copia independiente
      this.lstCiudad2 = resp.slice(); // Crear una copia independiente
      const index = this.lstCiudad.findIndex(item => item.nombre === 'TODAS LAS CIUDADES');
      if (index !== -1) {
        this.lstCiudad.splice(index, 1);
      }
      this.lstCiudad.push({ id: 0, nombre: 'TODAS LAS CIUDADES', clave_estado: '', id_ciudad_principal: 0, clave_tipoTransporte: 0 });
      setTimeout(() => {
        this.loading = false;
        this.dsblstCiudades = false;
      }, 1000);
    },
    (error) => {
      this.loading = false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
    });
  }



clv_activo: number= 0;
nombre_registro:string ='';
verMenosdesgloce(){}

//dspDesgloce:boolean=false;
nom_chofer:string ='';
desc_puesto:string ='';
imp_total:number=0;
imp_deduccion_echamelaMano:number=0;
imp_deduccion_infonavit:number=0;
imp_deduccion_descuentos_varios:number=0;
fec_inicio:Date =new Date;
fec_fin: Date=new Date
id_semana:number =0;
mostrardesgloce(data: IDeducciones){
  this.nom_chofer = data.nom_chofer;
  this.desc_puesto = data.desc_puesto;
  this.imp_total = data.imp_total;

  this.imp_deduccion_echamelaMano = data.imp_deduccion_echamelaMano;
  this.imp_deduccion_infonavit = data.imp_deduccion_infonavit;
  this.imp_deduccion_descuentos_varios = data.imp_deduccion_descuentos_varios;
  this.fec_inicio = data.fec_inicio;
this.id_semana= data.id_semana;
  this.nombre_registro ='Desgloce'



 // this.dspDesgloce= true
}

obtenerDescripcionDeduccion(data: any): string {
  if (data.imp_deduccion_echamelaMano > 0) {
    return 'Echame la Mano';
  } else if (data.imp_deduccion_infonavit > 0) {
    return 'Deducción Infonavit';
  } else if (data.imp_deduccion_descuentos_varios > 0) {
    return 'Descuentos Varios';
  } else {
    return '';
  }
}
  saveAsExcelFile(buffer: any, fileName: string): void {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_exportar_" + dateFormat + EXCEL_EXTENSION);
  }



  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }


  // ----------------reportes  ------------
  abrirModalReportes() {
    this.dbsReportes = true;
    this.inicializarFechasFormateadas();
  }


  cancelarModalReportes() {
    this.dbsReportes = false;
    // Inicio Reporte 1
    this.selectedMesReporte1 = {
      num_mes: 0,
      nombre: ''
    }
    this.anioReporte1 = null;
    this.selectedCiudad = {
      id: -1,
      nombre: '',
      clave_Estado: '',
      id_ciudad_principal: 0
    };
    this.fecha_fin = null;
    this.selectedSemanaReporte = {
      idx: 0,
      id_semana: 0,
      nom_semana: '',
      anio: 0,
      fec_inicio: '',
      fec_fin: '',
      clv_activo: 0
    };
    this.id_ciudad_hm_rpt =0;
  }



  inicializarFechasFormateadas() {
    //hacer globales
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    this.fecha_dia = dateFormat;
    this.fecha_del_dia = new Date(dateFormat + 'T00:00:00');
    //Fecha que no se modifica
    this.fecha_final_dia = new Date(dateFormat + 'T00:00:00');
    //Fecha para restar los 3 dias
    let minus3days = new Date(this.fecha_final_dia);
    this.fecha_minus3 = new Date(minus3days.setDate(new Date(minus3days).getDate() - 4));
    //Fecha del dia real, no se mueve
    this.fecha_dia_real = dateFormat;
    //Reportes
    let num_mes: number = +getMonth;
    this.meses.map((mes) => {
      if (mes.num_mes == num_mes) {
        this.selectedMesReporte1.nombre = mes.nombre;
        this.selectedMesReporte1.num_mes = mes.num_mes;
      }
    });
    this.anioReporte1 = getYear;
  }

  reciboPDF(cod_chofer: number, nombre_completo: string) {
    let id_semana = this.selectedSemana ? this.selectedSemana.id_semana : 0;
    let num_anio_semana = this.selectedSemana ? this.selectedSemana.anio : 0;

    this.recibodigitalService.getRecibo(this.anio_filtro, id_semana, cod_chofer).subscribe(
      (archivo: Blob) => {
        const archivoUrl = URL.createObjectURL(archivo);

        // Reemplazar espacios por guiones bajos en el nombre del chofer
        const nombreArchivo = `ReciboDeNomina_semana_${this.selectedSemana.id_semana}_${this.selectedSemana.anio}_${nombre_completo.replace(/\s+/g, '_')}.pdf`;

        // Crear un enlace <a> para descargar el archivo
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', archivoUrl);
        link.setAttribute('download', nombreArchivo);

        // Agregar el enlace al cuerpo del documento y activar el clic
        document.body.appendChild(link);
        link.click();

        // Limpiar el enlace del DOM después de la descarga
        document.body.removeChild(link);

        // Liberar recursos de la URL del archivo
        URL.revokeObjectURL(archivoUrl);
      },
      error => {
        console.error('Error al descargar el archivo:', error);
        // Manejar el error según tus necesidades
      }
    );
  }


  reciboactivities(cod_chofer: number, nombre_completo: string) {
    let id_semana = this.selectedSemana ? this.selectedSemana.id_semana : 0;
    let num_anio_semana = this.selectedSemana ? this.selectedSemana.anio : 0;

    this.recibodigitalService.getactivities(this.anio_filtro, id_semana, cod_chofer).subscribe(
      (archivo: Blob) => {
        const archivoUrl = URL.createObjectURL(archivo);

        // Reemplazar espacios por guiones bajos en el nombre del chofer
        const nombreArchivo = `DetalleDeActividades_semana_${this.selectedSemana.id_semana}_${this.selectedSemana.anio}_${nombre_completo.replace(/\s+/g, '_')}.pdf`;

        // Crear un enlace <a> para descargar el archivo
        const link = document.createElement('a');
        link.setAttribute('target', '_blank');
        link.setAttribute('href', archivoUrl);
        link.setAttribute('download', nombreArchivo);

        // Agregar el enlace al cuerpo del documento y activar el clic
        document.body.appendChild(link);
        link.click();

        // Limpiar el enlace del DOM después de la descarga
        document.body.removeChild(link);

        // Liberar recursos de la URL del archivo
        URL.revokeObjectURL(archivoUrl);
      },
      error => {
        console.error('Error al descargar el archivo:', error);
        // Manejar el error según tus necesidades
      }
    );
  }
  // metodo para exportar a excel
  // exportarExcel( ) {
  //   this.deshabilitarbtnexportar = true;
  //   if (this.id_ciudad_hm_rpt == null || typeof this.id_ciudad_hm_rpt === 'undefined' || !this.selectedSemanaReporte || this.selectedSemanaReporte.id_semana == null || typeof this.selectedSemanaReporte.id_semana === 'undefined') {
  //     this.mostrarDialogoInformativoSinInformacion('<b>Informativo</b> Debe seleccionar una semana para poder filtrar');
  //     this.deshabilitarbtnexportar = false;
  //   } else  {
  //     this.deduccionesService.rptDeducciones(this.selectedSemanaReporte.anio, this.selectedSemanaReporte.id_semana,this.id_ciudad_hm_rpt,)
  //       .subscribe((resp: IDeducciones[]) => {
  //         if (resp.length === 0 || typeof resp === 'undefined') {
  //           this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> debes de seleccionar una semana existe para poder exportar la informacion del Catalogo(Excel)');

  //           this.deshabilitarbtnexportar = false;
  //         } else {
  //           import("xlsx").then(xlsx => {
  //             const worksheet = xlsx.utils.json_to_sheet(resp);
  //             const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
  //             const excelBuffer: any = xlsx.write(workbook, {
  //               bookType: "xlsx",
  //               type: "array"
  //             });

  //             this.saveAsExcelFile(excelBuffer, "Reporte_Colaboradores_Deducciones"+ '_'+ 'semana'+'_'+this.selectedSemanaReporte.id_semana+  '_' + 'añio'+'_'+ this.selectedSemanaReporte.anio );
  //           });
  //           setTimeout(() => {
  //             this.ButtonExportExcel = false;
  //             this.deshabilitarbtnexportar = false;
  //             //this.cancelarModalReportes()
  //           }, 1000);
  //         }
  //       },
  //         (error) => {
  //           this.ButtonExportExcel = false;
  //           this.deshabilitarbtnexportar = false;
  //           this.fecha_fin = null;
  //           this.messageService.add({ key: 'msj', severity: 'error', summary: 'Error', detail: 'Error en emitir el reporte de Estatus de Facturación.' });
  //         });
  //   }
  // }



  mostrarDialogoInformativo(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario + '.';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
        this.messageService.clear();
      },
      key: "sinInformacionDialog"
    });
    this.loading = false;
    this.messageService.clear();
  }


}
